module.exports = __webpack_public_path__ + "static/media/greeitem4.3073fc1b.png";